export interface NewsArticle {
  article_id: string;
  title: string;
  short_description: string;
  content: string;
  thumbnail_s3_key?: string;
  thumbnail_url?: string;
  category_id: string;
  category_name: string;
  status: NewsArticleStatus;
  tags: string[];
  published_date: string | null;
  author: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_by: string | null;
}

export interface NewsArticleTranslate {
  status: string;
  message: string;
  article_id: string;
  source_lang: string;
  target_lang: string;
  cached: boolean;
  translated: {
    title: string;
    short_description: string;
    content: string;
  };
}

export enum NewsArticleStatus {
  DRAFT = "Draft",
  PUBLISHED = "Published",
  ARCHIVED = "Archived",
}

export interface NewsArticleParams {
  offset?: number;
  limit?: number;
  category_id?: string;
  status?: string;
  search?: string;
}

export interface NewsArticleResponse {
  items: NewsArticle[];
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface NewsArticleCategory {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
  article_count: number;
}

export interface AddNewsArticleParams {
  title: string;
  content: string;
  short_description: string;
  category_id: string;
  status: string;
  thumbnail_s3_key?: string;
  thumbnail_url?: string;
  tags?: string[];
  author?: string;
  created_by?: string;
  updated_by?: string;
  user?: string;
  email?: string;
}

export interface NewsArticleTranslateParams {
  title: string;
  short_description: string;
  content: string;
  target_lang: string;
}

export type NewsArticleCategoryResponse = {
  detail: {
    error_code: string;
    message: string;
  };
};

export type AddNewsArticleResponse = NewsArticleCategoryResponse;
